import { useBaseMutation } from "../../../../hooks/useBaseMutation";


export const useStoreStripeAccountLink = () => {
    
    return useBaseMutation(
        'put',
        'https://api.menufy.link/restaurantBackend/stores/stripeLink', // Endpoint
        // 'storeInfo',
        // Data transformation function
    );
};
